import { FETCH_WHATSAPP_CHARGES_SUCCESS, FETCH_WHATSAPP_CHARGES_REQUEST, FETCH_WHATSAPP_CHARGES_FAILURE, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getWhatsappChargesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_WHATSAPP_CHARGES_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case FETCH_WHATSAPP_CHARGES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case FETCH_WHATSAPP_CHARGES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getWhatsappChargesReducer;
